import { useState } from 'react';
import { useSelector } from 'react-redux';

const replaceInternal = (work) => {
  const arrayCaracteres = ['(', ')', '[', ']', '{', '}'];
  let data = work.toUpperCase();
  arrayCaracteres.map((caracter) => {
    data = data.replace(caracter, `\\${caracter}`);
    return null;
  });

  return data;
};

export const homeSearch = (jobs, queryParam) => {
  // const edgecaseremoval = jobs.filter((job) => Object.entries(job).length > 0)
  // return edgecaseremoval.filter((job) => {
  const array = [];
  jobs.map((job) => {
    const data = replaceInternal(queryParam.toUpperCase());
    if (new RegExp(`${data}.*`).test(job.jobTitle.toUpperCase())) array.push(job);
    return null;
  });
  return array;
  // return jobs.filter((job) => {
  //     // const textMatch = job.jobTitle.toUpperCase().includes(queryParam.toUpperCase())
  //     new RegExp(queryParam.toUpperCase() + '.*').test(job.jobTitle.toUpperCase())
  //     // const textMatch = job.jobTitle.toUpperCase().includes(queryParam.toUpperCase())
  //     // return textMatch
  // })
};

// eslint-disable-next-line import/prefer-default-export
export function Search({ setJobs, changedPagination }) {
  const [text, setText] = useState('');

  const jobs = useSelector((state) => state.jobs);

  const changedText = (event) => {
    const { value } = event.target;
    const values = homeSearch(jobs, value);
    setText(value);
    setJobs(values);
    changedPagination(null, 1);
  };

  return {
    text,
    changedText,
  };
}
